import BaseSessionStorageState from './base-session-storage-state';

export const KEYS = {
  SEARCH: 'search',
  MAP_VISIBLE: 'mapVisible',
  MAX_DISPLAYS: 'maxDisplays',
  MAX_DISPLAYS_ONLINE_LOCATIONS: 'maxDisplays.onlineLocations',
  MAX_DISPLAYS_OFFLINE_LOCATIONS: 'maxDisplays.offlineLocations',
  MAX_DISPLAYS_OTHER_LOCATIONS: 'maxDisplays.otherLocations',
  MAX_DISPLAYS_FAVOURITE_LOCATIONS: 'maxDisplays.favouriteLocations',
};

/**
 * Initially display at most this many locations.
 * @type {Number}
 */
const MAX_LOCATIONS_TO_DISPLAY_INIT = 9;

class LocationFilterState extends BaseSessionStorageState {
  constructor($log, $sessionStorage) {
    super($log, $sessionStorage)
    this.storageName = 'savedLocation';
    const initialState = Object.assign(this.getDefaults(), $sessionStorage[this.storageName]);
    this.$sessionStorage[this.storageName] = initialState;
  }

  getDefaults() {
    return {
      search: "",
      mapVisible: false,
      maxDisplays: {
        onlineLocations: MAX_LOCATIONS_TO_DISPLAY_INIT,
        offlineLocations: MAX_LOCATIONS_TO_DISPLAY_INIT,
        otherLocations: MAX_LOCATIONS_TO_DISPLAY_INIT,
        favouriteLocations: MAX_LOCATIONS_TO_DISPLAY_INIT,
      }
    }
  }
}

export default LocationFilterState;



// WEBPACK FOOTER //
// ./src/app/common/session-storage/location-filter-state.js